<style src="./Login.scss" lang="scss"></style>
<template>
  <div class="login-wrapper gray-bg">
    <div class="middle-box text-center loginscreen animated fadeInDown">
      <spinner size="large" message="Aguarde..." v-if="showSpinner"> </spinner>

      <div class="image-logo">
        <h1 class="name">Peace Parking</h1>
      </div>

      <form class="m-t" role="form" @submit.prevent>
        <div class="form-group">
          <input
            type="text"
            name="cpf"
            class="form-control login-text"
            placeholder="CPF"
            v-model="credentials.cpf"
            v-validate="'required'"
            :class="{ invalid: errors.has('cpf') }"
          />

          <span class="error">{{ errors.first('cpf') }}</span>
        </div>

        <div class="form-group">
          <input
            :type="fieldType"
            class="form-control input-btn login-text"
            name="password"
            placeholder="Senha"
            v-model="credentials.password"
            v-validate="'required|min:4'"
            :class="{ invalid: errors.has('password') }"
          />
          <span class="error">{{ errors.first('password') }}</span>
        </div>

        <div class="alert alert-danger" v-if="wrongUserOrPassword">
          Usuário ou senha incorreto. Tente novamente.
        </div>

        <br />

        <button class="btn btn-login btn-block" @click="login()">
          Entrar
        </button>

        <!-- <div class="text-center">
          <button type="button" class="btn btn-link">
            <router-link to="/forgot-password"
              ><small>Esqueci a senha</small></router-link
            >
          </button>
        </div> -->
      </form>

      <p class="m-t">
        <small>Peace Parking &copy; {{ year }} - v4.5.0</small>
      </p>
    </div>
  </div>
</template>

<script>
import { toast } from '@/mixins/toast';
import Spinner from '@/components/Spinner';

export default {
  mixins: [toast],
  components: { Spinner },
  data() {
    return {
      credentials: {
        cpf: '',
        password: '',
      },
      showSpinner: false,
      fieldType: 'password',
      year: new Date().getFullYear(),
      wrongUserOrPassword: false,
    };
  },
  mounted() {
    this.$store.commit('DATA-ACCESS/setUserToken', null);
  },
  methods: {
    passVisibility() {
      this.fieldType = this.fieldType === 'password' ? 'text' : 'password';
    },
    async login() {
      const isValid = await this.$validator.validate();
      if (!isValid) {
        return false;
      }

      try {
        await this.$store.dispatch('DATA-ACCESS/doLogin', this.credentials);
        this.$store.dispatch('MESSAGES/WatchMonitor');
        this.$router.push({ name: 'Welcome' });
      } catch (errors) {
        this.wrongUserOrPassword = true;
      }
    },
  },
};
</script>
